<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>{{ $route.meta.name }}管理</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.meta.name }}列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel">
      <el-page-header @back="$router.go(-1)" content="编辑订单">
      </el-page-header>
      <form class="form-horizontal" @submit.prevent="handleOrderUpdate">
        <div class="panel-body">
          <div class="row">
            <div class="col-lg-12">
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">新旧钻头</label>
                <div class="col-md-9">
                  <select
                    v-model.number="order.is_drill_new"
                    class="form-control"
                  >
                    <option value="1">新钻头</option>
                    <option value="2">旧钻头</option>
                  </select>
                </div>
              </div>
              <template v-if="order.is_drill_new == 2">
                <div class="form-group col-sm-4">
                  <label class="col-md-3 control-label">序列号</label>
                  <div class="col-md-9">
                    <input
                      type="text"
                      class="form-control"
                      :class="{
                        error: formCheck && !order.old_drill_serial_number,
                      }"
                      v-model="order.old_drill_serial_number"
                    />
                  </div>
                </div>
                <div class="form-group col-sm-4">
                  <label class="col-md-3 control-label">维修基地</label>
                  <div class="col-md-9">
                    <select
                      v-model="order.fix_base"
                      class="form-control"
                      :class="{ error: formCheck && !order.fix_base }"
                    >
                      <option :value="0">请选择</option>
                      <option :value="1">乌审旗</option>
                      <option :value="2">辽河</option>
                      <option :value="3">海锐</option>
                      <option :value="4">青海</option>
                      <option :value="5">新疆</option>
                    </select>
                  </div>
                </div>
              </template>
            </div>

            <div class="col-lg-12">
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">钻头类型</label>
                <div class="col-md-9">
                  <select
                    v-model="order.drill_type"
                    class="form-control"
                    :class="{ error: formCheck && !order.drill_type }"
                  >
                    <option :value="0">请选择</option>
                    <option :value="2">PDC钻头</option>
                    <option :value="3">复合钻头</option>
                    <option :value="4">矿用钻头</option>
                  </select>
                </div>
              </div>
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">规格</label>
                <div class="col-md-9">
                  <!-- <input
                      type="text"
                      class="form-control"
                      :class="{ error: formCheck && !order.drill_size }"
                      v-model="order.drill_size"
                    /> -->
                  <param-select
                    category="1"
                    :class="{ 'select-err': formCheck && !order.drill_size }"
                    v-model="order.drill_size"
                  ></param-select>
                </div>
              </div>
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">型号</label>
                <div class="col-md-9">
                  <input
                    type=""
                    class="form-control"
                    :class="{ error: formCheck && !order.model_number }"
                    v-model="order.model_number"
                  />
                </div>
              </div>
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">零件号</label>
                <div class="col-md-9">
                  <input
                    type=""
                    class="form-control"
                    :class="{ error: formCheck && !order.component_number }"
                    v-model="order.component_number"
                  />
                </div>
              </div>
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">数量</label>
                <div class="col-md-9">
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="order.drill_number"
                  />
                </div>
              </div>
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">使用区块</label>
                <div class="col-md-9">
                  <select
                    v-model="order.block_type"
                    class="form-control"
                    :class="{ error: formCheck && !order.block_type }"
                  >
                    <option :value="0">请选择</option>
                    <option :value="1">东北大区</option>
                    <option :value="2">陕北大区</option>
                    <option :value="3">西北大区</option>
                    <option :value="4">西南大区</option>
                    <option :value="6">中部大区</option>
                    <option :value="5">海纳</option>
                  </select>
                </div>
              </div>

              <!-- <div class="form-group col-sm-4">
                  <label class="col-md-3 control-label">下料</label>
                  <div class="col-md-9">
                    <select
                      v-model="order.cut_type"
                      class="form-control"
                      :class="{ error: formCheck && !order.cut_type }"
                    >
                      <option :value="0">请选择</option>
                      <option :value="1">成品</option>
                      <option :value="2">半成品</option>
                    </select>
                  </div>
                </div> -->
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">成品个数</label>
                <div class="col-md-9">
                  <input
                    type="number"
                    class="form-control"
                    v-model="order.cut_count_all"
                  />
                </div>
              </div>
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">半成品个数</label>
                <div class="col-md-9">
                  <input
                    type="number"
                    class="form-control"
                    v-model="order.cut_count_half"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-12 bord-top pad-top">
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">交货紧急程度</label>
                <div class="col-md-9">
                  <select
                    v-model="order.urgent_level"
                    class="form-control"
                    :class="{ error: formCheck && !order.urgent_level }"
                  >
                    <option :value="0">请选择</option>
                    <option :value="1">紧急</option>
                    <option :value="2">正常</option>
                    <option :value="3">一般</option>
                  </select>
                </div>
              </div>

              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">销售类型</label>
                <div class="col-md-9">
                  <select
                    v-model="order.sale_type"
                    class="form-control"
                    :class="{ error: formCheck && !order.sale_type }"
                  >
                    <option :value="0">请选择</option>
                    <option :value="1">服务</option>
                    <option :value="2">销售</option>
                  </select>
                </div>
              </div>

              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">喷嘴安装方式</label>
                <div class="col-md-9">
                  <select
                    v-model="order.nozzle_install_type"
                    class="form-control"
                    :class="{
                      error: formCheck && !order.nozzle_install_type,
                    }"
                  >
                    <option :value="0">请选择</option>
                    <option :value="1">上油</option>
                    <option :value="2">上胶</option>
                    <option :value="3">无喷嘴</option>
                  </select>
                </div>
              </div>

              <div class="form-group col-sm-4" v-if="order.is_drill_new == 2">
                <label class="col-md-3 control-label">维修方案</label>
                <div class="col-md-9">
                  <textarea
                    class="form-control"
                    :class="{ error: formCheck && !order.fix_plan_type }"
                    v-model="order.fix_plan_type"
                  ></textarea>
                </div>
              </div>

              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">喷嘴</label>
                <div class="col-md-9">
                  <input
                    type=""
                    class="form-control"
                    :class="{ error: formCheck && !order.nozzle }"
                    v-model="order.nozzle"
                  />
                </div>
              </div>

              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">包装</label>
                <div class="col-md-9">
                  <select
                    v-model="order.package_type"
                    class="form-control"
                    :class="{ error: formCheck && !order.package_type }"
                  >
                    <option :value="0">请选择</option>
                    <option :value="1">奥瑞拓</option>
                    <option :value="2">海纳</option>
                    <option :value="3">达坦</option>
                    <option :value="4">鼎鑫</option>
                    <option :value="5">其他</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="col-lg-12 bord-top pad-top">
              <div class="form-group col-sm-4">
                <label class="col-md-3 control-label">备注</label>
                <div class="col-md-9">
                  <textarea
                    class="form-control"
                    :class="{ error: formCheck && !order.remark }"
                    v-model="order.remark"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <div class="col-md-8 col-md-offset-4">
                <button class="btn btn-success btn-labeled">保存</button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import { orderShow, orderUpdate } from '@/service/getData'
import ParamSelect from '@/components/select/param_select'

export default {
  components: {
    DatePicker,
    ParamSelect,
  },
  data() {
    return {
      order: {},
      formCheck: false,
    }
  },
  watch: {
    'order.drill_number': function (v) {
      if (this.order.is_drill_new == 2) {
        this.order.drill_number = 1
      } else if (v < 1) {
        this.order.drill_number = 1
      }
    },
    'order.is_drill_new': function (v) {
      if (v == 2) {
        this.order.drill_number = 1
      }
    },
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let id = this.$route.params.id
      if (id) {
        let res = await orderShow(id)
        this.order = res.data
      }
    },
    async handleOrderUpdate() {
      this.formCheck = true
      if (
        !this.order.drill_type ||
        !this.order.drill_size ||
        !this.order.model_number ||
        !this.order.component_number ||
        !this.order.drill_number ||
        !this.order.block_type ||
        !this.order.urgent_level ||
        !this.order.sale_type ||
        !this.order.nozzle_install_type ||
        !this.order.nozzle ||
        !this.order.package_type ||
        !this.order.remark
      ) {
        return
      }
      if (this.order.is_drill_new == 2) {
        if (
          !this.order.old_drill_serial_number ||
          !this.order.fix_base ||
          !this.order.fix_plan_type
        ) {
          return
        }
      }
      let res = await orderUpdate(this.order)

      if (res.status == 0) {
        this.$router.go(-1)
      }
      // if (this.order.status == 6) {
      //   this.$router.push('/orders/archive')
      // } else {
      //   this.$router.push('/orders/index')
      // }
    },
  },
}
</script>